import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = "http://gantasoft.in/cab-g/dev/admin";

const CityVehicleFareManager = () => {
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);

  const [editData, setEditData] = useState(null);

  // 🔹 Load cities
  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCities = async () => {
    try {
      const res = await axios.get(`${API_BASE}/get_cities.php`);
      if (res.data.status) {
        setCities(res.data.cities);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Load fares by city
  const fetchVehicles = async (cityId) => {
    if (!cityId) return;

    setLoading(true);
    try {
      const res = await axios.get(
        `${API_BASE}/get_vehicle_fares.php?city_id=${cityId}`
      );

      if (res.data.status) {
        setVehicles(res.data.vehicles);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 On city change
  const handleCityChange = (e) => {
    const cityId = e.target.value;
    setSelectedCity(cityId);
    fetchVehicles(cityId);
  };

  // 🔹 Edit click
  const handleEdit = (item) => {
    setEditData({ ...item });
  };

  // 🔹 Update API
  const handleUpdate = async () => {
    try {
      const res = await axios.post(
        `${API_BASE}/update_fare_rule.php`,
        editData
      );

      alert(res.data.message);

      setEditData(null);
      fetchVehicles(selectedCity); // reload
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  return (
    <div className="p-6">

      <h2 className="text-2xl font-bold mb-4">Fare Rules Management</h2>

      {/* 🔽 City Dropdown */}
      <select
  value={selectedCity}
  onChange={handleCityChange}
  className="border p-2 rounded mb-5 w-64"
>
  <option value="">-- Select Location --</option>
  <option value="1">City</option>
  <option value="2">District</option>
</select>

      {/* 📊 Table */}
      {loading ? (
        <p>Loading...</p>
      ) : (
        vehicles.length > 0 && (
          <table className="w-full border shadow">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">Vehicle</th>
                <th className="p-2 border">Min Fare</th>
                <th className="p-2 border">Per KM</th>
                <th className="p-2 border">Per Min</th>
                <th className="p-2 border">Waiting</th>
                <th className="p-2 border">Action</th>
              </tr>
            </thead>

            <tbody>
              {vehicles.map((v) => (
                <tr key={v.vehicle_id} className="text-center">
                  <td className="border p-2 font-semibold">{v.display_name}</td>
                  <td className="border p-2">₹{v.min_fare_amount}</td>
                  <td className="border p-2">₹{v.per_km}</td>
                  <td className="border p-2">₹{v.per_min}</td>
                  <td className="border p-2">₹{v.waiting_per_min}</td>

                  <td className="border p-2">
                    <button
                      onClick={() => handleEdit(v)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )
      )}

      {/* ✏️ Edit Modal */}
      {editData && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
  <div className="bg-white p-6 rounded w-96 shadow-lg">

    <h2 className="text-lg font-bold mb-4">Edit Fare</h2>

    {/* Min Fare */}
    <label className="block text-sm font-medium mb-1">Min Fare</label>
    <input
      value={editData.min_fare_amount}
      onChange={(e) =>
        setEditData({ ...editData, min_fare_amount: e.target.value })
      }
      className="w-full border p-2 mb-3 rounded"
      placeholder="Enter Min Fare"
    />

    {/* Per KM */}
    <label className="block text-sm font-medium mb-1">Per KM</label>
    <input
      value={editData.per_km}
      onChange={(e) =>
        setEditData({ ...editData, per_km: e.target.value })
      }
      className="w-full border p-2 mb-3 rounded"
      placeholder="Enter Per KM"
    />

    {/* Per Min */}
    <label className="block text-sm font-medium mb-1">Per Minute</label>
    <input
      value={editData.per_min}
      onChange={(e) =>
        setEditData({ ...editData, per_min: e.target.value })
      }
      className="w-full border p-2 mb-3 rounded"
      placeholder="Enter Per Minute"
    />

    {/* Waiting */}
    
    <label className="block text-sm font-medium mb-1">Waiting Per Minute</label>
    <input
      value={editData.waiting_per_min}
      onChange={(e) =>
        setEditData({
          ...editData,
          waiting_per_min: e.target.value,
        })
      }
      className="w-full border p-2 mb-3 rounded"
      placeholder="Enter Waiting Charges"
    />

    {/* Night Multiplier */}
    <label className="block text-sm font-medium mb-1">Night Multiplier</label>
    <input
      value={editData.night_multiplier}
      onChange={(e) =>
        setEditData({
          ...editData,
          night_multiplier: e.target.value,
        })
      }
      className="w-full border p-2 mb-3 rounded"
      placeholder="Enter Night Multiplier"
    />
<label className="block text-sm font-medium mb-1">Id</label>
    <input
      value={editData.id}
      onChange={(e) =>
        setEditData({
          ...editData,
          id: e.target.value,
        })
      }
      className="w-full border p-2 mb-3 rounded"
      placeholder="Enter Waiting Charges" disabled
    />
    {/* Buttons */}
    <div className="flex justify-between mt-4">
      <button
        onClick={handleUpdate}
        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        Save
      </button>

      <button
        onClick={() => setEditData(null)}
        className="bg-gray-400 px-4 py-2 rounded hover:bg-gray-500"
      >
        Cancel
      </button>
    </div>

  </div>
</div>
      )}
    </div>
  );
};

export default CityVehicleFareManager;